/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/cadastro/produtos-conta/$productId/envolvidos')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/cadastro/produtos-conta/$productId',
      params,
      search: { tab: 'envolvidos' },
    });
  },
});
